import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight';
import classnames from 'classnames';

import { Button } from 'ui-components/components/button';
import { noop } from 'ui-components/default-props/noop';

import style from './modal-navigation-button.module.less';

/**
 * @param {object} props
 * @param {string} [props.className] - Optional custom className
 * @param {() => void} [props.onClick] - Click handler function
 * @param {boolean} [props.disabled] - Whether the button is disabled
 * @param {'left' | 'right'} [props.arrowDirection] - Direction of arrow icon
 * @returns {JSX.Element}
 */
const ModalNavigationButton = ({ className = '', onClick = noop, disabled = false, arrowDirection = 'left' }) => {
  const icon = arrowDirection === 'left' ? faArrowLeft : faArrowRight;
  return (
    <Button className={classnames(className, style['modal-navigation-button'])} disabled={disabled} onClick={onClick} theme='unstyled'>
      <FontAwesomeIcon icon={icon} />
    </Button>
  );
};

export default ModalNavigationButton;
